module.exports = __webpack_public_path__ + "website/img/topBg_r.0d4e9657.png";